// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__eFsiZ","name":"Header_name__1GBWJ","birthday":"Header_birthday__23-T1","skeleton":"Header_skeleton__3UM2L"};